import CreditCardItem from './CreditCardItem';

export default CreditCardItem;
